import { Injectable } from '@angular/core';
import { LiteratureDocument } from '@types';

@Injectable({ providedIn: 'root' })
export class LiteratureRulesHelperService {
  public checkLiteratureRules(data: LiteratureDocument): void {
    if (
      !data.clientUse ||
      data.orderLimit === 0 ||
      (data.isOrdItself === 'N' && !data.exemptCustomers) ||
      data.isInv === 'N'
    ) {
      data.hardCopyNotAvailable = true;
    }
    if (data.mandatoryMaterial?.length > 0) {
      data.isMandatoryMaterial = true;
    }
    if (data.restrictedDealer?.length > 0) {
      data.litDealerUse = true;
    }
  }
}
